import { Search, X } from 'lucide-react'
import { useState } from 'react'
import { Button } from '@/common/ui/button'
import { Sheet, SheetContent, SheetTrigger } from '@/common/ui/sheet'
import { COMMON_COPY, NAVIGATION_COPY } from '@/locales/en'
import { SearchButtonClickedAnalytics } from '@/common/analytics/events/SearchButtonClickedAnalytics'
import InstrumentSearch from './InstrumentSearch'

export function MobileInstrumentSearchDialog() {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger asChild>
                <Button
                    variant="ghost"
                    size="icon"
                    className="h-9 w-9 p-2 rounded-[96px] bg-white/70 shadow-[0px_4px_24px_0px_rgba(0,0,0,0.25)] backdrop-blur-[8px] md:hidden"
                    aria-label={NAVIGATION_COPY.instrumentSearch.triggerAriaLabel}
                    aria-haspopup="dialog"
                    onClick={() => {
                        SearchButtonClickedAnalytics.track()
                    }}
                >
                    <Search className="h-4 w-4 text-content-secondary" />
                </Button>
            </SheetTrigger>

            <SheetContent
                side="top"
                data-search-dialog-content
                aria-label={NAVIGATION_COPY.instrumentSearch.title}
                overlayClassName="bg-transparent"
                className="!inset-0 !h-full !w-full !max-w-none !border-0 !rounded-none bg-[#EDEDED]/64 backdrop-blur-[16px]"
            >
                <div data-search-dialog-overlay className="absolute inset-0" />

                <div className="relative h-full w-full bg-transparent">
                    <Button
                        variant="ghost"
                        size="icon"
                        className="absolute right-4 top-4 z-10 h-8 w-8 rounded-full bg-white/70 shadow-[0px_4px_24px_0px_rgba(0,0,0,0.18)] flex items-center justify-center text-content-secondary transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
                        aria-label={COMMON_COPY.close}
                        onClick={() => setIsOpen(false)}
                    >
                        <X className="h-4 w-4" />
                        <span className="sr-only">{COMMON_COPY.close}</span>
                    </Button>

                    <div className="h-14" />
                    <InstrumentSearch variant="mobile-sheet" autoFocus={isOpen} onItemClick={() => setIsOpen(false)} />
                </div>
            </SheetContent>
        </Sheet>
    )
}
